import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid';

export const MOBILE_FOOTER_HEIGHT_PX = 58;
/** Scroll padding so content clears sticky action bar + footer FAB on mobile */
export const MOBILE_STICKY_BOTTOM_INSET_PX = 114;

export const Container = styled(Grid)`
    .MuiFormControl-root {
        width: 100%;
    }
`;

export const EventCollection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled(Grid)`
  padding: 16px 20px;
  position: fixed;
  width: 100%;
  bottom: 55px;
  background: white;
  box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 3;

  @media (max-width: 600px) {
    bottom: ${MOBILE_FOOTER_HEIGHT_PX}px;
    padding: 12px 20px 24px;
  }
`;

export const Intro = styled(Grid)`
  padding: 20px;
  color: #53627C;
  border-bottom: 1px solid #dadadc;
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
    width: 19px;
    height: 19px;
  }
`;
